import { faBars, faXmark } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useHeaderContext } from '~/components/layout/Header/HeaderContext';
import HeaderLogo from '~/components/layout/Header/HeaderLogo';
import HeaderNavigation from '~/components/layout/Header/Navigation';
import NavigationMegaMenus from '~/components/layout/Header/Navigation/NavigationMegaMenus';
import Container from '~/components/ui/Container';
import { cn } from '~/helpers/utils';

const HeaderBar = () => {
  const {
    variant,
    wrapLogoInH1,
    headroom,
    mobileOpen,
    onMobileToggle,
    headerRef,
  } = useHeaderContext();

  return (
    <header
      ref={headerRef}
      role="banner"
      className={cn(
        'sticky top-0 z-[999999] transition-transform duration-300',
        headroom === 'unpinned' ? '-translate-y-full' : 'translate-y-0',
        variant === 'light' ? 'bg-white' : 'bg-blue-900'
      )}
    >
      <Container>
        <div className="flex h-16 items-center justify-between md:h-20">
          <HeaderLogo variant={variant} wrapLogoInH1={wrapLogoInH1} />
          <HeaderNavigation />
          <button
            className={cn(
              'flex h-10 w-10 items-center justify-center rounded transition-colors md:hidden',
              variant === 'dark'
                ? 'text-stone-400 hover:bg-blue-800'
                : 'text-stone-700 hover:bg-stone-100'
            )}
            onClick={onMobileToggle}
            aria-label={mobileOpen ? 'Menu sluiten' : 'Menu openen'}
            aria-expanded={mobileOpen}
            aria-controls="mobile-nav"
          >
            <FontAwesomeIcon
              icon={mobileOpen ? faXmark : faBars}
              className="h-5 w-5"
            />
          </button>
        </div>
      </Container>
      <NavigationMegaMenus />
    </header>
  );
};

export default HeaderBar;
